import ApiSetting from '@/request/api/setting'
import axios from '@/request/http'
import querystring from 'querystring'

const mediaApi = {
  delete (params) {
    return axios.post(
      `${ApiSetting.baseUrl}/api/media/delete/`, querystring.stringify(params))
  }
}

export default mediaApi
